import React, { FunctionComponent } from 'react';
import Editor, { ReactQuillProps } from 'react-quill';
import clsx from 'clsx';
import useStyles from './styles';
import 'react-quill/dist/quill.snow.css';

export type QuillEditorProps = ReactQuillProps;

const QuillEditor: FunctionComponent<ReactQuillProps> = ({ className, ...rest }: ReactQuillProps) => {
    const classes = useStyles();
    const classNameMerged = clsx(classes.root, className);
    return <Editor theme="snow" className={classNameMerged} {...rest} />;
};

export default QuillEditor;
